import { useMyUser } from 'shared/context/getMyUser.js';
import { useCompanyContext } from 'shared/context/useCompanyContext.js';

export const useCompanyContextSelectEffects = () => {
  const { companyId, setSelectedCompany } = useCompanyContext();
  const { user } = useMyUser();

  return {
    selectedCompanyId: companyId,
    setCurrentCompany: setSelectedCompany,

    field: {
      name: 'companyId',
      options: user?.companies?.map(c => ({
        value: c.id,
        label: c.name,
      })) ?? [],
    },
  };
};
